/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconArrowDown8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDown8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M6.57 1.72 3.975 4.311 1.38 1.719A.75.75 0 0 0 .32 2.781l3.125 3.122a.75.75 0 0 0 1.06 0L7.63 2.78a.75.75 0 0 0-1.06-1.062Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowDown12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDown12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M9.57 3.62 5.975 7.211 2.38 3.619A.75.75 0 0 0 1.32 4.68l4.125 4.123a.75.75 0 0 0 1.06 0L10.63 4.68a.75.75 0 1 0-1.06-1.06Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowDown16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDown16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M12.793 4.793 8 9.583l-4.793-4.79a1 1 0 0 0-1.414 1.414l5.5 5.497a1 1 0 0 0 1.414 0l5.5-5.497a1 1 0 0 0-1.414-1.414Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowDown20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDown20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="m10 11.796 5.293-5.293a1 1 0 1 1 1.414 1.414l-5.646 5.646a1.5 1.5 0 0 1-2.122 0L3.293 7.917a1 1 0 0 1 1.414-1.414L10 11.796Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowDown24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDown24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m12 14.586 6.293-6.293a1 1 0 1 1 1.414 1.414l-6.646 6.647a1.5 1.5 0 0 1-2.122 0L4.293 9.707a1 1 0 0 1 1.414-1.414L12 14.586Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconArrowDown = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowDown(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconArrowDown8 {...iconProps} />;
        case '12':
            return <IconArrowDown12 {...iconProps} />;
        case '16':
            return <IconArrowDown16 {...iconProps} />;
        case '20':
            return <IconArrowDown20 {...iconProps} />;
        case '24':
            return <IconArrowDown24 {...iconProps} />;
        default:
            return <IconArrowDown24 {...iconProps} />;
    }
});
